<template>
    <b-form
        class="auth-login-form mt-2"
        ref="MEGAZONE_AUTH_POPS"
        action="https://login.megazonejapan.jp/oauth/authorize"
    >
        <input type="hidden" name="response_type" value="code">
        <input type="hidden" name="client_id" :value="VUE_APP_POPS_CLIENT_ID">
        <input type="hidden" name="redirect_uri" :value="VUE_APP_POPS_CLIENT_REDIRECT_URI + '/oauth/authorize'">
        <button
            class="mz-btn"
            type="submit"
            block
            @click="signinWithPops"
        >
            <img
                :src="`${logoBaseUrl}/icon_megazonecloud.png`"
                alt="Log in with Megazone Account"
            >
            <span>
                Log in with Megazone Account
            </span>
        </button>
    </b-form>
</template>
<script>
import useEnvString from '@/composables/useEnvString'
import { ref, computed, getCurrentInstance } from '@vue/composition-api'
export default {
    setup () {
        const vm = getCurrentInstance().proxy

        const {
            VUE_APP_HYPER_V3_CONTENT,
            VUE_APP_POPS_LOGIN,
            VUE_APP_POPS_CLIENT_ID,
            VUE_APP_POPS_CLIENT_REDIRECT_URI
        } = useEnvString()
        const logoBaseUrl = VUE_APP_HYPER_V3_CONTENT + '/logo'
        const needOtpLogin = ref(false)
        const isPopsLogin = computed(() => (VUE_APP_POPS_LOGIN === 'TRUE'))

        const MEGAZONE_AUTH_POPS = ref(null)
        const signinWithPops = () => {
            if (MEGAZONE_AUTH_POPS.value) {
                vm.$refs.MEGAZONE_AUTH_POPS.submit()
            }
        }
        return {
            MEGAZONE_AUTH_POPS,
            VUE_APP_POPS_CLIENT_ID,
            VUE_APP_POPS_CLIENT_REDIRECT_URI,
            logoBaseUrl,
            needOtpLogin,
            isPopsLogin,
            signinWithPops
        }
    }
}
</script>
